import React, { useState } from 'react';
import { Check, ChevronsUpDown, Globe } from 'lucide-react';
import { TIMEZONES } from '../../constants/timezones';
import { Button } from './button';
import { cn } from '../../lib/utils';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./popover";

export function TimezoneSelector({ value, onChange, className }) {
  const [open, setPopoverOpen] = useState(false);

  const selectedTz = TIMEZONES.find((tz) => tz.value === value) || { value: value || 'UTC', label: value || 'UTC' };

  return (
    <Popover open={open} onOpenChange={setPopoverOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn(
            "w-full justify-between bg-muted/30 border-2 border-border/50 text-foreground shadow-sm rounded-2xl h-12 px-5 font-bold transition-all hover:border-primary/50",
            className
          )}
        >
          <div className="flex items-center gap-2 truncate">
            <Globe className="w-4 h-4 text-primary opacity-70 shrink-0" />
            <span className="truncate">{selectedTz.label}</span>
          </div>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0 bg-card border-border shadow-2xl rounded-2xl z-[10000]">
        <Command className="rounded-2xl">
          <CommandInput placeholder="Search country, city or timezone..." className="h-12 border-none focus:ring-0 font-bold" />
          <CommandList className="max-h-64 custom-scrollbar">
            <CommandEmpty>No timezone found.</CommandEmpty>
            <CommandGroup>
              {TIMEZONES.map((tz) => (
                <CommandItem
                  key={tz.value}
                  value={`${tz.country} ${tz.label} ${tz.value} USA America US United States`}
                  onSelect={() => {
                    onChange(tz.value);
                    setPopoverOpen(false);
                  }}
                  className="flex items-center justify-between py-3 px-4 cursor-pointer hover:bg-muted font-bold transition-colors"
                >
                  <div className="flex flex-col">
                    <span className="text-sm">{tz.label}</span>
                    <span className="text-[10px] text-muted-foreground uppercase tracking-widest">{tz.country}</span>
                  </div>
                  <Check
                    className={cn(
                      "ml-2 h-4 w-4 text-primary",
                      value === tz.value ? "opacity-100" : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
